import { observer } from 'mobx-react';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';

const styles = require('./markdown.css');
/** Props for the select option */
export interface MarkdownContentProps {
  // /** Additional classes to apply */
  // className?: string;
  text: string;
  /** Suppress opening in external tab or page */
  noTarget?: boolean;
  // /** Run code before activating link */
  // onSubmit?(e: React.FormEvent): void;
}

/**
 * Convenience Markdown Wrapper
 * This is useful because protoapp uses a CSS Reset
 * ReactMarkdown assumes that the appropriate elements (e.g. <strong>) are styled appropriately
 * So we need to redefine/apply these styles after the css reset - which this component does
 */
@observer
export class MarkdownContent extends React.Component<MarkdownContentProps> {
  render(): JSX.Element {
    /// Longstanding request from business: Open links in external page or tab.
    /// NB Must set the *rel* attribute as shown; see https://medium.com/@jitbit/target-blank-the-most-underestimated-vulnerability-ever-96e328301f4c
    ///    This is why can't use linkTarget as it's insufficient to set target without these other parameters
    const renderers = this.props.noTarget
      ? undefined
      : {
          link: (props: HTMLAnchorElement) => {
            // if (props.href.match('http')) {
            return (
              <a href={props.href} target={'_blank'} rel="nofollow noreferrer noopener">
                {props.children}
              </a>
            );
            // }
            // return <a href={props.href}>{props.children}</a>
          }
        };
    return (
      <div className={styles.markdown}>
        <ReactMarkdown
          escapeHtml={false}
          source={this.props.text}
          // linkTarget={'_blank'}
          renderers={renderers}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/markdown-content/markdown-content.tsx